import { CaretCircleLeft } from '@phosphor-icons/react'
import React from 'react'
import { BackButtonContainer, BackButtonIcon, BackButtonText } from './styles'

interface BackButtonProps {
  goTo: string
}

export const BackButton = ({ goTo }: BackButtonProps) => {
  return (
    <BackButtonContainer
      type="button"
      onClick={() =>
        setTimeout(() => {
          window.location.href = '/' + goTo
        }, 500)
      }
    >
      <BackButtonIcon>
        <CaretCircleLeft size={14} weight="fill" color="#52427B" />
      </BackButtonIcon>
      <BackButtonText>Voltar</BackButtonText>
    </BackButtonContainer>
  )
}
